import { z } from 'zod';
export const RiskLevel = z.enum(['NONE', 'LOW', 'MEDIUM', 'HIGH', 'CRITICAL']);
export const RISK_VALUE = {
    NONE: 0,
    LOW: 1,
    MEDIUM: 2,
    HIGH: 3,
    CRITICAL: 4,
};
export const OperationType = z.enum([
    'FILE_CREATE', 'FILE_MODIFY', 'FILE_DELETE', 'FILE_RENAME',
    'DIR_CREATE', 'DIR_DELETE', 'DEPENDENCY_CHANGE', 'CONFIG_CHANGE',
]);
//# sourceMappingURL=risk.js.map